export const googlePlayStoreUrl = 'https://play.google.com/store/apps/details?id=com.mobile_proctor&pcampaignid=web_share'
export const iosAppStoreUrl = 'https://apps.apple.com/us/app/mereos/id6504674029';